export const activity = {
screenTitle: "Activité",
badgeContractor: "Espace prestataire",
segmentInbox: "Notifications",
segmentFeed: "Activité de l’espace de travail",
notifications: "Notifications",
notificationFallback: "Notification",
recentUpdates: "Mises à jour récentes",
fullFeed: "Fil complet",
pendingApproval: "En attente de votre réponse",
reviewRequired: "Examen requis",
inspectionReportMeta: "Rapport d’inspection",
viewAsset: "Voir l’actif",
approvedForRepair: "Approuvé pour réparation",
repairsApproved_one: "{{count}} réparation approuvée",
repairsApproved_other: "{{count}} réparations approuvées",
createJobs: "Créer des interventions",
awaitingRecipient: "En attente du destinataire",
firstShared: "Premier envoi {{date}}",
resent: "Renvoyé {{date}}",
waitingForReview: "En attente d’examen",
resendDeadline: "Renvoyer et mettre à jour l’échéance",
jobInvitations: "Invitations à des interventions",
jobFallbackTitle: "Intervention n°{{id}}",
acceptOrDecline: "Accepter ou refuser",
accept: "Accepter",
decline: "Refuser",
reportsSharedWithYou: "Rapports partagés avec vous",
inspectionReportCard: "Rapport d’inspection",
emptyInboxTitle: "Rien ne requiert votre attention",
emptyInboxSub: "Les approbations, invitations et réponses qui vous attendent apparaissent ici.",
feedTitle: "Fil d’activité",
emptyFeedTitle: "Aucune activité d’équipe pour l’instant",
emptyFeedSub: "Les affectations d’interventions, changements de statut et approbations de toute l’équipe apparaissent ici.",
events: {
  inspectionSentBack: "Inspection renvoyée",
jobAssigned: "Intervention assignée",
jobAssignedTo: "Intervention assignée à {{name}}",
jobAccepted: "Intervention acceptée",
jobRejected: "Intervention refusée",
jobRejectedBy: "Intervention refusée par {{name}}",
jobStarted: "Intervention démarrée",
jobScheduled: "Intervention planifiée",
jobReportShared: "Rapport d'intervention partagé",
teamMemberJoined: "A rejoint l'équipe",
jobPaused: "Intervention en pause",
jobResumed: "Intervention reprise",
completionSubmitted: "Achèvement soumis",
jobVerified: "Intervention vérifiée",
reworkRequested: "Retouche demandée",
reworkRequestedBy: "Retouche demandée par {{name}}",
evidenceRequested: "Preuves supplémentaires demandées",
evidenceRequestedBy: "Preuves supplémentaires demandées par {{name}}",
jobStatusChanged: "Intervention : {{status}}",
jobUpdatedFallback: "mis à jour",
contractorInvited: "Prestataire invité à l’intervention",
contractorAccepted: "Le prestataire a accepté l’intervention",
contractorDeclined: "Le prestataire a refusé l’intervention",
quoteRequestSent: "Demande de devis envoyée",
quoteSubmitted: "Devis soumis",
quoteAccepted: "Devis accepté",
quoteRejected: "Devis refusé",
quoteDeclined: "Demande de devis refusée",
contractorAwarded: "Prestataire retenu",
inspectionShared: "Inspection partagée",
inspectionCompleted: "Inspection terminée",
inspectionApproved: "Inspection approuvée",
requestCreated: "Demande déposée",
requestApproved: "Demande approuvée",
requestDeclined: "Demande refusée",
requestConverted: "Demande transformée en travail",
requestClosed: "Demande clôturée",
assetDecommissioned: "Actif mis hors service",
assetRetired: "Actif retiré définitivement",
connectedAlert: "Alerte d’appareil",
assetCreated: "Actif ajouté",
assetUpdated: "Actif mis à jour",
assetDeleted: "Actif supprimé",
assetInService: "Actif remis en service",
contactAdded: "Contact ajouté",
contactSharedTeam: "Contact partagé avec l’équipe",
contactPromoted: "Contact converti en compte",
contactInvited: "Contact invité",
contactLinked: "Contact lié",
assetRelAdded: "Relation d’actif ajoutée",
assetRelUpdated: "Relation d’actif mise à jour",
assetRelRemoved: "Relation d’actif supprimée",
duplicateMarked: "Doublon d’actif marqué",
canonicalSet: "Actif canonique défini",
duplicatesMerged: "Doublons d’actifs fusionnés",
approvalWithAsset: "Inspection pour {{asset}} approuvée par {{recipient}}",
approvalByRecipient: "Rapport approuvé par {{recipient}}",
approvalGeneric: "Rapport d’inspection approuvé",
rejectionWithAsset: "Inspection pour {{asset}} rejetée par {{recipient}}",
rejectionByRecipient: "Rapport rejeté par {{recipient}}",
rejectionGeneric: "Rapport d’inspection rejeté",
},
jobStatus: {
draft: "Brouillon",
open: "Ouvert",
accepted: "Accepté",
scheduled: "Planifié",
inProgress: "En cours",
paused: "En pause",
completed: "Terminé",
verified: "Vérifié",
rejected: "Rejeté",
cancelled: "Annulé",
},
insights: {
  kpiName: {
    portfolio_condition: "État général",
    assets_good_condition: "Actifs en bon état",
    inspection_pass_rate: "Inspections réussies",
    first_time_fix: "Réparé du premier coup",
    backlog_weeks: "Travail en attente (semaines)",
    mttr: "Délai moyen de réparation",
    maintenance_approval_turnaround: "Délai d’approbation",
    maintenance_reassignment_rate: "Travaux réattribués",
    maintenance_reschedule_rate: "Maintenance reportée",
    maintenance_missed_rate: "Maintenance manquée",
    maintenance_skip_rate: "Maintenance ignorée",
    on_time_completion: "Terminé à temps",
    reactive_vs_planned: "Travaux non planifiés",
    pm_schedule_compliance: "Maintenance planifiée à l’heure",
    cert_currency: "Certificats à jour",
    statutory_compliance: "Conformité réglementaire",
  },
  kpiTarget: "Objectif {{target}}",
  headlineKpi: {
    health: "Santé",
    riskLevel: "Niveau de risque",
    atRisk: "Actifs à risque",
    outOfService: "Hors service",
    onTime: "À temps",
    compliance: "Conformité",
    ofTotal: "sur {{total}}",
    noCompletedJobsWithDueDates: "aucune intervention terminée avec échéance",
    nothingToProveYet: "rien à justifier pour l’instant",
    registerNotLoaded: "registre de conformité non chargé",
  },
  kpiDetail: {
    requirementsCompliant_one: "{{compliant}} sur {{count}} exigence respectée",
    requirementsCompliant_many: "{{compliant}} sur {{count}} d’exigences respectées",
    requirementsCompliant_other: "{{compliant}} sur {{count}} exigences respectées",
    certsCurrent: "{{valid}} sur {{total}} en cours de validité",
    onSchedule: "{{completed}} sur {{total}} dans les temps",
    jobsReactive_one: "{{reactive}} sur {{count}} intervention non planifiée",
    jobsReactive_many: "{{reactive}} sur {{count}} d’interventions non planifiées",
    jobsReactive_other: "{{reactive}} sur {{count}} interventions non planifiées",
    onTime: "{{onTime}} sur {{total}} à temps",
    plannedOccurrences_one: "{{done}} sur {{count}} occurrence planifiée",
    plannedOccurrences_many: "{{done}} sur {{count}} d’occurrences planifiées",
    plannedOccurrences_other: "{{done}} sur {{count}} occurrences planifiées",
    pastDueNoDecision: "{{missed}} sur {{total}} en retard sans décision",
    movedWithDelay_one: "{{moved}} sur {{total}}, {{count}} jour de retard en moyenne",
    movedWithDelay_many: "{{moved}} sur {{total}}, {{count}} de jours de retard en moyenne",
    movedWithDelay_other: "{{moved}} sur {{total}}, {{count}} jours de retard en moyenne",
    moved: "Reportées : {{moved}} sur {{total}}",
    decidedWaiting: "Tranchées : {{decided}}, en attente : {{pending}}",
    decided: "Tranchées : {{decided}}",
    completedJobs_one: "{{count}} intervention terminée",
    completedJobs_many: "{{count}} d’interventions terminées",
    completedJobs_other: "{{count}} interventions terminées",
    noOpenJobs: "Aucune intervention ouverte",
    noRecentCompletions: "Aucune intervention terminée récemment pour estimer le rythme",
    openPerWeek: "Ouvertes : {{open}} · {{rate}}/sem.",
    reopenedOf: "Rouvertes : {{reopened}} sur {{total}}",
    itemsOf_one: "{{pass}} sur {{count}} point",
    itemsOf_many: "{{pass}} sur {{count}} de points",
    itemsOf_other: "{{pass}} sur {{count}} points",
    postureCounts: "{{clear}} en bon état · {{watch}} à surveiller · {{action}} à traiter",
    atRiskOf: "{{atRisk}} sur {{total}} à risque",
  },
  kpiUnit: {
    days: "{{value}} j",
    weeks: "{{value}} sem.",
  },
  kpiTargetValue: {
    reactive: "≤ 20 % non planifié",
    oneDay: "≤ 1 jour",
    trendDown: "tendance à la baisse",
    trendUp: "tendance à la hausse",
    underFourWeeks: "< 4 semaines",
    rework: "reprises ≤ 5 %",
  },
  forecast: {
    certificatesLapse_one: "{{count}} certificat expire d’ici {{days}} jours",
    certificatesLapse_many: "{{count}} de certificats expirent d’ici {{days}} jours",
    certificatesLapse_other: "{{count}} certificats expirent d’ici {{days}} jours",
    moreSuffix_one: "+{{count}} autre",
    moreSuffix_many: "+{{count}} autres",
    moreSuffix_other: "+{{count}} autres",
    backlogStalled_one: "{{count}} intervention en attente n’est pas traitée",
    backlogStalled_many: "{{count}} d’interventions en attente ne sont pas traitées",
    backlogStalled_other: "{{count}} interventions en attente ne sont pas traitées",
    backlogStalledDetail: "Aucune intervention terminée ces 4 dernières semaines — sans action, le travail en attente continuera d’augmenter.",
    backlogGrowing: "Le travail en attente devrait atteindre ~{{projected}} d’ici 4 semaines",
    backlogGrowingDetail: "{{inflow}}/sem. entrantes contre {{velocity}}/sem. traitées — la capacité est inférieure à la demande.",
    backlogBurndown: "Le travail en attente sera résorbé dans ~{{weeks}} semaines au rythme actuel",
    backlogBurndownDetail: "Ouvertes : {{open}} · {{velocity}}/sem. traitées contre {{inflow}}/sem. entrantes.",
    declineTitle: "{{name}} risque de passer bientôt à « Action recommandée »",
    declineDetailDocument: "Actuellement « À surveiller » ({{score}}/100) ; {{regulation}} expire d’ici 30 jours.",
    declineDetailSchedule: "Actuellement « À surveiller » ({{score}}/100) avec une inspection planifiée à échéance ou en retard.",
  },
  sections: {
    a11y: "Sections de l’Analytique",
    workflows: "Flux de travail",
    overview: "Vue d’ensemble",
  },
chart: {
emptyReason: {
noRecords: "Aucun enregistrement disponible",
noQualifyingRecords: "Aucun enregistrement éligible",
filteredEmpty: "Aucune correspondance pour ces filtres",
insufficientSample: "Pas encore assez de preuves",
notApplicable: "Sans objet",
loadFailed: "Impossible de charger les données du graphique",
stale: "Les données doivent être actualisées",
},
defaultAccessibilityLabel: "Graphique",
},
shell: {
hideDetails: "Masquer les détails de l’analyse",
showDetailsSuffix: "Afficher les détails de l'analyse.",
expandHint: "Appuyez deux fois pour agrandir le panneau d'informations complet",
},
conditionPortfolio: {
stableCount_one: "{{count}} stable.",
stableCount_many: "{{count}} stables.",
stableCount_other: "{{count}} stables.",
band: {
critical: "Critique",
action_recommended: "Action recommandée",
deteriorating: "En dégradation",
watch: "À surveiller",
stable: "État stable",
},
bandInfo: {
critical: "Actifs dont les éléments montrent qu’ils demandent une attention immédiate : points de sécurité en échec, travaux urgents en retard ou déclin rapide.",
action_recommended: "Actifs qui se dégradent et pour lesquels une action planifiée est conseillée avant qu’ils ne deviennent critiques.",
deteriorating: "Actifs dont les inspections, réparations ou l’historique de maintenance montrent un déclin régulier.",
watch: "Actifs présentant un signe d’alerte précoce à surveiller, pas encore un déclin.",
},
noDominantDriver: "Aucun facteur ne se démarque.",
recurringFault_one: "{{count}} actif avec un défaut récurrent",
recurringFault_other: "{{count}} actifs avec un défaut récurrent",
repeatRepairs: "{{count}} avec des réparations répétées",
noExceptions: "Aucun défaut récurrent ni réparation répétée sur l'ensemble du portefeuille.",
noteSuffix: "Les relevés de compteur sont affichés sur chaque actif, pas ici.",
moreOnList: "+{{count}} de plus dans la liste des actifs.",
wholeCountsNote: "Les décomptes couvrent tous les actifs, au {{date}}. Les actifs listés sont des exemples parmi ceux chargés.",
recurringFault_many: "{{count}} actifs avec un défaut récurrent",
},
panel: {
basedOn: "Basé sur : {{source}}",
severityHighPriority: "Haute priorité",
severityAttention: "Attention",
severityOnTrack: "En bonne voie",
severityFyi: "Pour info",
severityNote: "Remarque",
moreItems: "+{{count}} de plus ici — affinez ou recherchez pour réduire.",
signalsTitle: "Signaux",
recommendedActionTitle: "Action recommandée",
},
kpiInfo: {
aboutLabel: "À propos de {{label}}",
hint: "Ouvre une explication de cette métrique et comment l'utiliser",
},
metricInfoSheet: {
dismissOverlay: "Ignorer",
close: "Fermer",
whatItMeasures: "CE QU’IL MESURE",
howToUseIt: "COMMENT L'UTILISER",
basedOn: "BASÉ SUR",
asOf: "Au · {{value}}",
target: "Objectif · {{value}}",
},
priorityCard: {
feedbackHelpful: "Utile",
feedbackNotUseful: "Pas utile",
feedbackSnooze: "Reporter",
feedbackDismiss: "Ignorer",
recommended: "Recommandé : {{action}}.",
effort: "Effort : {{value}}",
expectedBenefit: "Bénéfice attendu : {{value}}",
dataGaps: "Lacunes dans les données",
butAlso: "Mais aussi",
feedbackTrigger: "Avis sur l’analyse",
feedbackSheetTitle: "Est-ce que cela a été utile ?",
},
journeys: {
tabExecutive: "Direction",
tabRequest: "Demande",
tabInspection: "Inspection",
tabJob: "Intervention",
tabAsset: "Actif",
tabContractor: "Prestataire",
tabCompliance: "Conformité",
tablistLabel: "Tableaux de bord des parcours",
executiveAssistantTitle: "Assistant de direction",
pageTitle: "Analyse des parcours",
journeyCount_one: "{{count}} parcours",
journeyCount_other: "{{count}} parcours",
requestFunnel: "Entonnoir des demandes",
journeyFunnel: "Entonnoir des parcours",
stageFlow: "Flux par étape",
noJourneyFlow: "Aucun flux de parcours pour l'instant.",
durationDistribution: "Répartition de la durée des parcours",
noCompletedJourneys: "Aucun parcours terminé pour l'instant.",
bottlenecksMedianGap: "Goulots d’étranglement (écart médian entre étapes)",
bottleneckEmpty: "Rien de mesuré pour l'instant. Un goulot d'étranglement nécessite au moins un parcours ayant complété deux étapes consécutives (par exemple demande → approbation).",
workFunnel: "Entonnoir du travail",
bottleneckRanking: "Classement des goulots d’étranglement",
recentJourneyActivity: "Activité récente des parcours",
noRecentEvents: "Aucun événement récent.",
slaComplianceByStage: "Conformité au SLA par étape",
slaEmpty: "Rien n'est encore mesuré. Cela se remplit dès qu'une demande est approuvée, qu'une inspection donne lieu à une intervention, ou qu'une intervention est commencée ou terminée — les écarts entre ces étapes sont ce que mesure la conformité au SLA.",
bottlenecks: "Goulots d’étranglement",
whatNeedsAttention: "Ce qui nécessite une attention particulière",
journeyCount_many: "{{count}} parcours",
},
screen: {
  aiSummaryButton: "Rédiger un résumé IA",
  emptyStartInspection: "Lancer une inspection",
  emptyAddAsset: "Ajouter un actif",
scopeAllMultiTeam: "Le travail de tous : idéal pour comparer les équipes côte à côte.",
scopeAllSingleTeam: "Tout le travail sur votre compte.",
scopePersonalMultiTeam: "Juste votre travail. Basculez vers Tous pour voir toute l’équipe.",
scopePersonalSingleTeam: "Juste votre travail.",
scopeTeamMultiTeam: "Seul {{team}} est inclus. Basculez la portée sur Tous pour comparer les équipes côte à côte.",
scopeTeamSingleTeam: "Seul {{team}} est inclus.",
greetingLate: "Vous travaillez tard",
greetingMorning: "Bonjour",
greetingAfternoon: "Bon après-midi",
greetingEvening: "Bonsoir",
greetingNoPriorities: "Aucune priorité aujourd'hui. Tendances ci-dessous à mesure que les données s'accumulent.",
greetingDanger_one: "{{count}} problème nécessite votre attention aujourd'hui — l'élément principal présente un risque élevé.",
greetingDanger_other: "{{count}} problèmes nécessitent votre attention aujourd’hui — l’élément principal présente un risque élevé.",
greetingTechnician_one: "Vous avez {{count}} tâche à faire. Commencez par la première carte.",
greetingTechnician_other: "Vous avez {{count}} tâches à faire. Commencez par la première carte.",
greetingExecutive_one: "{{count}} élément mérite votre attention, le plus coûteux en premier.",
greetingExecutive_other: "{{count}} éléments méritent votre attention, les plus coûteux en premier.",
greetingTeam_one: "{{count}} priorité pour l'équipe aujourd'hui.",
greetingTeam_other: "{{count}} priorités pour l’équipe aujourd’hui.",
loadingTitle: "Chargement de l’Analytique",
emptyGetsUsefulTitle: "L’Analytique devient utile à l’usage",
emptyGetsUsefulDescription: "Ajoutez un actif ou lancez une inspection. L’Analytique montrera ensuite ce qui demande votre attention et ce qui prend du retard.",
partialDataCaption: "Ces graphiques utilisent des enregistrements chargés. Les totaux du portefeuille peuvent être incomplets.",
partialDataCaptionConditionWhole: "L’état, le niveau de risque, les actifs à risque et hors service couvrent tous les actifs. Les autres chiffres et graphiques utilisent les enregistrements chargés et peuvent être incomplets.",
partialDataCaptionConditionBandsWhole: "L’état, le niveau de risque, les actifs à risque et hors service, les bandes d’état et les actifs en bon état couvrent tous les actifs. Les autres chiffres et graphiques utilisent les enregistrements chargés et peuvent être incomplets.",
refreshErrorTitle: "Certaines données de l’Analytique n’ont pas pu être actualisées",
refreshErrorDescription: "Les graphiques ci-dessous utilisent des données mises en cache et peuvent être incomplets. Réessayez lorsque votre connexion sera disponible.",
roleTechnician: "Technicien",
roleManager: "Responsable",
roleExecutive: "Direction",
switchToRoleView: "Passer à la vue {{role}}",
resetToAutoLabel: "Réinitialiser la vue détectée automatiquement",
resetToAutoText: "Revenir à la vue auto",
showingLabel: "Affichage",
clearSiteFilter: "Effacer le filtre de site",
allSites: "Tous les sites",
unassignedSite: "Non assigné",
selectedSiteFallback: "Site sélectionné",
standardsEyebrow: "Normes",
operationalKpisTitle: "KPI opérationnels",
subtitleNeedAttention_one: "{{count}} nécessite votre attention · {{onTrack}} dans l’objectif",
subtitleNeedAttention_other: "{{count}} nécessitent votre attention · {{onTrack}} dans l’objectif",
subtitleAllOnTarget_one: "{{count}} KPI atteint l’objectif",
subtitleAllOnTarget_many: "Les {{count}} KPI atteignent l’objectif",
subtitleAllOnTarget_other: "Les {{count}} KPI atteignent l’objectif",
asOfSuffix: "mis à jour à {{time}}",
kpiAllClearAccessibilityLabel_one: "{{count}} KPI atteint l’objectif. Tout afficher.",
kpiAllClearAccessibilityLabel_many: "Les {{count}} KPI atteignent l’objectif. Tout afficher.",
kpiAllClearAccessibilityLabel_other: "Les {{count}} KPI atteignent l’objectif. Tout afficher.",
kpiAllClearText_one: "{{count}} KPI atteint l’objectif",
kpiAllClearText_many: "Les {{count}} KPI atteignent l’objectif",
kpiAllClearText_other: "Les {{count}} KPI atteignent l’objectif",
showAllLabel: "Afficher tout",
hideOnTargetKpis: "Masquer les KPI qui atteignent l’objectif",
showOnTargetKpis_one: "Afficher {{count}} KPI qui atteint l’objectif",
showOnTargetKpis_other: "Afficher {{count}} KPI qui atteignent l’objectif",
conditionEyebrow: "État",
conditionTitle: "Quels actifs se détériorent ?",
conditionSubtitle: "Dérivé de l’historique des inspections, des réparations et de l’entretien. Appuyez sur un actif pour obtenir des preuves complètes.",
maintenanceEyebrow: "Maintenance",
maintenanceTitle: "Où la maintenance prend-elle du retard ?",
maintenanceSubtitle: "Un travail sauté a été décidé ; un travail manqué ne l'a pas été. Ils sont comptabilisés séparément.",
sitesEyebrow: "Sites",
sitesTitle: "Quel site nécessite une attention particulière ?",
sitesSubtitle: "Santé par site, le pire en premier. Appuyez sur un site pour concentrer tout le tableau de bord dessus.",
focusOnSiteLabel: "Se concentrer sur {{name}}. Santé {{score}} sur 100.",
healthDetail: "Santé {{score}}/100 · {{atRisk}} sur {{total}} à risque",
profileEyebrow: "Complétude du profil",
profileTitle: "Actifs avec des détails de profil manquants",
profileSubtitle: "Il manque à ces fiches d'actifs des champs utilisés par les listes de contrôle, les calculs de risque et les recommandations.",
profileRowLabel: "{{needsData}} actifs sur {{total}} ont des profils incomplets. Ouvrez la liste.",
profileRowTitle: "{{needsData}} profils d’actifs sur {{total}} sont incomplets",
profileWeak_one: "{{count}} actif présente très peu de détails structurés. Ouvrez la liste pour combler les lacunes.",
profileWeak_other: "{{count}} actifs ont très peu de détails structurés. Ouvrez la liste pour combler les lacunes.",
profileOpenList: "Ouvrez la liste pour vérifier et remplir les champs manquants.",
forecastEyebrow: "Prévisions",
forecastTitle: "À venir",
forecastSubtitle: "Prévu en fonction des expirations des certificats, des planifications et du rythme d'achèvement : agissez avant qu'il ne dérape.",
todayEyebrow: "Aujourd'hui",
topPrioritiesTitle: "Principales priorités",
subtitleTechnician: "Vos prochaines interventions, classées par urgence.",
subtitleManager: "Top 5 des priorités classées sur votre périmètre, avec justification et action recommandée.",
visibleOfTotal: "{{visible}} sur {{total}}",
viewDetailsLabel: "Voir les détails",
workloadLabel: "Charge de travail",
reportingInsightLabel: "Analyse des rapports",
clearedTitle: "Rien à signaler.",
clearedBody: "Aucune priorité pour le moment ; nous en ferons apparaître de nouvelles au fur et à mesure que les données arriveront.",
riskEyebrow: "Risque",
riskTitle: "Où se concentre le risque ?",
riskSubtitle: "Exposition classée sur l'ensemble du portefeuille, ventilée par criticité et mode de défaillance.",
rankedCount_one: "{{count}} classé",
rankedCount_many: "{{count}} classés",
rankedCount_other: "{{count}} classés",
topExposuresEyebrow: "Principales expositions liées à l’état",
topExposuresTitle: "Quels actifs sont les plus exposés ?",
nextAssetCaption: " Suivant : {{name}} (santé {{score}}/100).",
riskHeatmapEyebrow: "Carte thermique des risques",
riskHeatmapTitle: "Criticité × type d'actif",
riskHeatmapCaption: "Cellules plus foncées = score de risque moyen plus élevé.",
riskByCriticalityEyebrow: "Risque par criticité",
riskByCriticalityTitle: "Comment le risque est-il réparti par niveau de criticité ?",
riskByCriticalityCaption_one: "{{count}} actif à risque · Score de risque de 50/100 ou plus. Les actifs inférieurs à ce seuil peuvent encore avoir des travaux en retard.",
riskByCriticalityCaption_other: "{{count}} actifs à risque · Score de risque de 50/100 ou plus. Les actifs inférieurs à ce seuil peuvent encore avoir des travaux en retard.",
topFailuresEyebrow: "Principales catégories de pannes",
topFailuresTitle: "Qu'est-ce qui échoue le plus souvent ?",
topFailuresCaption_one: "{{label}} arrive en tête avec {{count}} élément signalé ; recherchez la cause profonde.",
topFailuresCaption_other: "{{label}} arrive en tête avec {{count}} éléments signalés ; recherchez la cause profonde.",
fewerAnalytics: "Moins d’analyses",
moreAnalytics: "Plus d'analyses",
flowEyebrow: "Flux",
flowTitle: "Comment se déroule le travail ?",
flowSubtitle: "Forme du travail en attente et qualité des inspections sur les 28 derniers jours.",
backlogEyebrow: "Composition du travail en attente",
backlogTitle: "Le retard diminue-t-il ou augmente-t-il ?",
backlogCaption: "Aujourd'hui : {{overdue}} en retard · {{dueSoon}} bientôt attendu · {{upcoming}} à venir.",
legendOverdue: "En retard",
legendDueIn7d: "Échéance sous 7 j",
legendUpcoming: "À venir",
passRateEyebrow: "Taux de réussite des inspections",
passRateTitle: "Les inspections tendent-elles vers la réussite ou l’échec ?",
passRateCaption: "Actuellement {{current}}% (vs {{prev}}% il y a 28 jours — {{arrow}} {{delta}}pts).",
passRateEmpty: "Exécutez davantage d'inspections pour renseigner la tendance.",
noScheduledTitle: "Aucun élément programmé pour l'instant.",
noScheduledDescription: "Une fois les interventions et les inspections datées disponibles, les tendances de la charge de travail apparaîtront ici.",
teamsEyebrow: "Equipes & partenaires",
teamsTitle: "Quelles sont les performances des équipes et des sous-traitants ?",
teamsSubtitle: "Les classements utilisent votre portée actuelle ({{scope}}). Comparez les équipes lorsque la portée est Tous.",
compareTeamsTitle: "Comparez les équipes côte à côte",
compareTeamsBody: "Vous consultez {{scope}}. Basculez vers Tous pour voir la charge de travail et le débit classés dans chaque équipe.",
switchToAll: "Passer à tous",
switchScopeAllLabel: "Passez le périmètre sur Tous pour comparer les équipes",
teamWorkloadEyebrow: "Charge de travail de l’équipe",
teamWorkloadTitle: "Quelles équipes portent le plus de travail ouvert ?",
teamThroughputEyebrow: "Débit de l’équipe",
teamThroughputTitle: "Qui a réalisé le plus de travaux en 28 jours ?",
cycleTimesShown: "Temps de cycle affichés lorsque les interventions terminées ont des dates de début et de fin.",
completedCountsCaption: "Nombre d’éléments terminés au cours des 28 derniers jours dans votre portée actuelle.",
openLabel_one: "{{count}} ouvert",
openLabel_many: "{{count}} ouverts",
openLabel_other: "{{count}} ouverts",
overdueUnassigned: "{{overdue}} en retard · {{unassigned}} non attribué",
unassignedOnly_one: "{{count}} non attribué",
unassignedOnly_many: "{{count}} non attribués",
unassignedOnly_other: "{{count}} non attribués",
doneLabel_one: "{{count}} terminé",
doneLabel_many: "{{count}} terminés",
doneLabel_other: "{{count}} terminés",
avgCycleDays: "Cycle moyen : {{days}} j",
stillOpen_one: "{{count}} toujours ouvert",
stillOpen_many: "{{count}} toujours ouverts",
stillOpen_other: "{{count}} toujours ouverts",
contractorPerformanceEyebrow: "Performance des prestataires",
contractorPerformanceTitle: "Comment les entrepreneurs se comportent-ils les uns par rapport aux autres ?",
overdueOnly_one: "{{count}} en retard",
overdueOnly_many: "{{count}} en retard",
overdueOnly_other: "{{count}} en retard",
doneWindow_one: "{{count}} terminé (28 j)",
doneWindow_many: "{{count}} terminés (28 j)",
doneWindow_other: "{{count}} terminés (28 j)",
sentBack_one: "{{count}} renvoyé",
sentBack_many: "{{count}} renvoyés",
sentBack_other: "{{count}} renvoyés",
avgCycle: "{{days}} j en moyenne",
toAnswer: "{{hours}} h pour répondre",
declinedOnly_one: "{{count}} refusé",
declinedOnly_many: "{{count}} refusés",
declinedOnly_other: "{{count}} refusés",
techQualityEyebrow: "Qualité des techniciens",
techQualityTitle: "Quels techniciens ont besoin d'un accompagnement ?",
techQualityCaption_one: "Le score combine l'achèvement dans les délais moins les réouvertures (0-100). Médiane {{median}}/100 sur {{count}} technicien.",
techQualityCaption_other: "Le score combine l’achèvement dans les délais moins les réouvertures (0-100). Médiane {{median}}/100 sur {{count}} techniciens.",
technicianFallback: "Technicien",
needsCoaching: "A besoin de coaching",
starPerformer: "Meilleur performeur",
onTrack: "En bonne voie",
slippageEyebrow: "Retards",
slippageTitle: "Qu’est-ce qui prend du retard ?",
slippageSubtitle: "Couverture des inspections, manquements à la conformité et lacunes dans votre cadence d'inspection.",
coverageGapsEyebrow: "Lacunes de couverture",
coverageGapsTitle: "Quels actifs nécessitent une inspection maintenant ?",
coverageGapsCaptionKnown: "Élément principal : {{label}} ({{days}} j depuis la dernière inspection). Les éléments sont triés par jours × impact opérationnel.",
coverageGapsCaptionNever: "Élément principal : {{label}} (jamais inspecté). Les éléments sont triés par jours × impact opérationnel.",
neverLabel: "Jamais",
complianceExpirationsEyebrow: "Expirations de conformité",
complianceExpirationsTitle: "Qu'est-ce qui expire dans les 90 prochains jours ?",
complianceExpirationsCaption: "{{expired}} a déjà expiré, {{expiringSoon}} expirant dans les 14 jours.",
overdueDays: "{{days}} j de retard",
daysLeft: "{{days}} j restants",
inspectionDensityEyebrow: "Densité d'inspection",
inspectionDensityTitle: "Où se trouvent les écarts de cadence ?",
inspectionDensityCaption_one: "{{count}} inspection au cours des ~6 derniers mois. Les périodes vides signalent des lacunes de couverture.",
inspectionDensityCaption_many: "{{count}} inspections au cours des ~6 derniers mois. Les périodes vides signalent des lacunes de couverture.",
inspectionDensityCaption_other: "{{count}} inspections au cours des ~6 derniers mois. Les périodes vides signalent des lacunes de couverture.",
activityEyebrow: "Activité",
activityTitle: "Que vient-il de se passer ?",
activitySubtitle: "Dernières inspections et mises à jour des interventions dans toute votre portée.",
whenToday: "aujourd'hui",
whenYesterday: "hier",
whenDaysAgo: "il y a {{days}} j",
severityFooterText: "La gravité est indiquée sous forme d’impact opérationnel (faible → critique), et non sous forme de valeurs monétaires. AssetWRX ne gère pas le P&L — les données de coûts relèvent de votre ERP. Lorsque vous en connectez un, des montants en $ peuvent être ajoutés ici.",
askTitle: "Demander à AssetWRX",
askPlaceholderExecutive: "par ex. Quels sites ont coûté le plus cher le trimestre dernier ?",
askPlaceholderTechnician: "par ex. Quelles sont mes interventions aujourd'hui ?",
askPlaceholderManager: "par ex. Quels actifs doivent être inspectés ?",
askButton: "Demander",
pageSubtitle: "Découvrez où le travail s'accumule, quels actifs sont à risque et qui est surchargé.",
greetingDanger_many: "{{count}} problèmes nécessitent votre attention aujourd’hui — l’élément principal présente un risque élevé.",
greetingTechnician_many: "Vous avez {{count}} tâches à faire. Commencez par la première carte.",
greetingExecutive_many: "{{count}} éléments méritent votre attention, les plus coûteux en premier.",
greetingTeam_many: "{{count}} priorités pour l’équipe aujourd’hui.",
subtitleNeedAttention_many: "{{count}} nécessitent votre attention · {{onTrack}} dans l’objectif",
showOnTargetKpis_many: "Afficher {{count}} KPI qui atteignent l’objectif",
profileWeak_many: "{{count}} actifs ont très peu de détails structurés. Ouvrez la liste pour combler les lacunes.",
riskByCriticalityCaption_many: "{{count}} actifs à risque · Score de risque de 50/100 ou plus. Les actifs inférieurs à ce seuil peuvent encore avoir des travaux en retard.",
topFailuresCaption_many: "{{label}} arrive en tête avec {{count}} éléments signalés ; recherchez la cause profonde.",
techQualityCaption_many: "Le score combine l’achèvement dans les délais moins les réouvertures (0-100). Médiane {{median}}/100 sur {{count}} techniciens.",
},
},
repairsApproved_many: "{{count}} réparations approuvées",
title: "Activité",
viewFeed: "Voir l’activité de l’équipe",
analyticsTitle: "Analytique",
recommendations: {
whyPrefix: "Pourquoi :",
failureTitle: "{{asset}} — Santé {{score}}/100",
impactRisk: "Risque",
actionOpenAsset: "Ouvrir l’actif",
actionScheduleAction: "Planifier une action",
actionAssignTechnician: "Attribuer un technicien",
thinHistory: "Historique limité pour cet actif — enregistrez une inspection pour fiabiliser le score.",
overdueTitle_one: "{{count}} intervention en retard dans votre périmètre",
overdueTitle_many: "{{count}} d’interventions en retard dans votre périmètre",
overdueTitle_other: "{{count}} interventions en retard dans votre périmètre",
overdueWhy: "Pourquoi : des échéances sont passées sans que le travail soit terminé — le travail en attente s’accumule.",
impactOldest: "La plus ancienne",
oldestValue_one: "{{count}} j de retard",
oldestValue_many: "{{count}} j de retard",
oldestValue_other: "{{count}} j de retard",
actionTriageBacklog: "Trier le travail en attente",
complianceTitle_one: "{{count}} élément de conformité expire dans 30 jours",
complianceTitle_many: "{{count}} d’éléments de conformité expirent dans 30 jours",
complianceTitle_other: "{{count}} éléments de conformité expirent dans 30 jours",
complianceWhy: "Pourquoi : les certifications et les inspections expirent si rien n’est fait.",
impactAtRisk: "À risque",
assetsCount_one: "{{count}} actif",
assetsCount_many: "{{count}} d’actifs",
assetsCount_other: "{{count}} actifs",
actionOpenCompliance: "Ouvrir la conformité",
trainingTitle_one: "{{count}} technicien avec des réouvertures répétées",
trainingTitle_many: "{{count}} de techniciens avec des réouvertures répétées",
trainingTitle_other: "{{count}} techniciens avec des réouvertures répétées",
trainingWhy: "Pourquoi : la même catégorie d’actifs a été rouverte plusieurs fois en 90 j — probablement un besoin de formation.",
impactRecurringRework: "Reprises récurrentes",
reopensCount_one: "{{count}} réouverture",
reopensCount_many: "{{count}} de réouvertures",
reopensCount_other: "{{count}} réouvertures",
actionViewContacts: "Voir les contacts",
inspectionDueTitle_one: "{{count}} actif doit être inspecté",
inspectionDueTitle_many: "{{count}} d’actifs doivent être inspectés",
inspectionDueTitle_other: "{{count}} actifs doivent être inspectés",
inspectionDueWhy: "Pourquoi : aucune inspection terminée au cours des 90 derniers jours.",
impactCoverageGap: "Lacune de couverture",
actionScheduleInspections: "Planifier des inspections",
approvalsInspections_one: "{{count}} inspection en attente d’approbation",
approvalsInspections_many: "{{count}} d’inspections en attente d’approbation",
approvalsInspections_other: "{{count}} inspections en attente d’approbation",
approvalsJobs_one: "{{count}} intervention en attente de vérification",
approvalsJobs_many: "{{count}} d’interventions en attente de vérification",
approvalsJobs_other: "{{count}} interventions en attente de vérification",
approvalsTitle_one: "{{count}} décision vous attend",
approvalsTitle_many: "{{count}} de décisions vous attendent",
approvalsTitle_other: "{{count}} décisions vous attendent",
approvalsWhyOne: "Pourquoi : {{part}}. Le travail reste ouvert tant que personne ne l’a validé.",
approvalsWhyBoth: "Pourquoi : {{first}} et {{second}}. Le travail reste ouvert tant que personne ne l’a validé.",
impactWaiting: "En attente",
actionReviewApprove: "Examiner et approuver",
jobFallback: "Intervention",
nextJobDue: "Pourquoi : échéance le {{date}}.",
nextJobAssigned: "Pourquoi : elle vous est attribuée.",
impactUrgency: "Urgence",
actionOpenJob: "Ouvrir l’intervention",
},
insightQuality: {
confidenceHigh: "Confiance élevée",
confidenceMedium: "Confiance moyenne",
confidenceLow: "Confiance faible",
notEnoughHistory: "{{label}} · historique récent insuffisant",
basedOnOne: "{{label}} · d’après {{part}}",
basedOnBoth: "{{label}} · d’après {{first}} et {{second}}",
inspections_one: "{{count}} inspection",
inspections_many: "{{count}} d’inspections",
inspections_other: "{{count}} inspections",
jobs_one: "{{count}} intervention",
jobs_many: "{{count}} d’interventions",
jobs_other: "{{count}} interventions",
noInspectionsInScope: "Aucune inspection dans le périmètre",
limitedJobHistory: "Historique d’interventions limité",
noCompletedInspections: "Aucune inspection terminée",
noInspectionInDays_one: "Aucune inspection depuis {{count}} jour",
noInspectionInDays_many: "Aucune inspection depuis {{count}} de jours",
noInspectionInDays_other: "Aucune inspection depuis {{count}} jours",
noInspectionHistory: "Aucun historique d’inspection",
assetMetadataIncomplete: "Métadonnées de l’actif incomplètes",
noRecentTimestamps: "Aucun horodatage d’activité récente",
dataGapNoInspection_one: "Données manquantes : aucune inspection depuis {{count}} jour",
dataGapNoInspection_many: "Données manquantes : aucune inspection depuis {{count}} de jours",
dataGapNoInspection_other: "Données manquantes : aucune inspection depuis {{count}} jours",
dataGapLastActivity_one: "Données manquantes : dernière activité il y a {{count}} jour",
dataGapLastActivity_many: "Données manquantes : dernière activité il y a {{count}} de jours",
dataGapLastActivity_other: "Données manquantes : dernière activité il y a {{count}} jours",
limitedData: "Données limitées — à prendre comme une simple tendance",
},
activityTimeline: {
inspectionCompleted: "Inspection terminée",
inspectionInProgress: "Inspection en cours",
itemsFlagged_one: "{{count}} élément signalé",
itemsFlagged_many: "{{count}} d’éléments signalés",
itemsFlagged_other: "{{count}} éléments signalés",
allPassing: "Tous les éléments sont conformes",
jobUpdated: "Intervention mise à jour",
},
portfolioNarrative: {
flat: "La santé du portefeuille est de {{score}}/100 — les tendances apparaîtront à mesure que les données s’accumulent.",
improved_one: "Votre portefeuille se porte mieux ce mois-ci — la santé opérationnelle a gagné {{count}} point pour atteindre {{score}}/100{{driver}}.",
improved_many: "Votre portefeuille se porte mieux ce mois-ci — la santé opérationnelle a gagné {{count}} de points pour atteindre {{score}}/100{{driver}}.",
improved_other: "Votre portefeuille se porte mieux ce mois-ci — la santé opérationnelle a gagné {{count}} points pour atteindre {{score}}/100{{driver}}.",
improvedDriver_one: ", car {{count}} actif est sorti de la tranche à risque",
improvedDriver_many: ", car {{count}} d’actifs sont sortis de la tranche à risque",
improvedDriver_other: ", car {{count}} actifs sont sortis de la tranche à risque",
slipped_one: "La santé du portefeuille a reculé de {{count}} point ce mois-ci, à {{score}}/100.",
slipped_many: "La santé du portefeuille a reculé de {{count}} de points ce mois-ci, à {{score}}/100.",
slipped_other: "La santé du portefeuille a reculé de {{count}} points ce mois-ci, à {{score}}/100.",
steady: "La santé du portefeuille est restée stable à {{score}}/100 ce mois-ci.",
concern: " À surveiller : {{concern}}.",
},
partnersCaptions: {
teamEmpty: "Attribuez des interventions à des équipes pour comparer leur charge de travail et leur débit.",
teamSingle: "{{team}} : {{open}} en cours, {{completed}} terminée(s) en {{days}} j.",
teamOverdue: "{{worst}} a le plus de travail en retard ({{overdue}}) ; {{leader}} a la plus grande file de travail en cours ({{open}}).",
teamThroughput: "{{leader}} a la plus grande file de travail en cours ; {{top}} a clôturé le plus d’interventions en {{days}} j ({{completed}}).",
teamLeader_one: "{{leader}} a la plus grande file de travail en cours ({{count}} intervention).",
teamLeader_many: "{{leader}} a la plus grande file de travail en cours ({{count}} d’interventions).",
teamLeader_other: "{{leader}} a la plus grande file de travail en cours ({{count}} interventions).",
contractorEmpty: "Attribuez des interventions réalisées par des prestataires pour voir leur performance ici.",
contractorOverdue_one: "{{worst}} a {{count}} intervention en retard ; {{leader}} a la plus forte charge active ({{open}} en cours).",
contractorOverdue_many: "{{worst}} a {{count}} d’interventions en retard ; {{leader}} a la plus forte charge active ({{open}} en cours).",
contractorOverdue_other: "{{worst}} a {{count}} interventions en retard ; {{leader}} a la plus forte charge active ({{open}} en cours).",
contractorRework_one: "{{name}} a eu {{count}} intervention renvoyée ; {{leader}} est en tête des attributions en cours ({{open}}).",
contractorRework_many: "{{name}} a eu {{count}} d’interventions renvoyées ; {{leader}} est en tête des attributions en cours ({{open}}).",
contractorRework_other: "{{name}} a eu {{count}} interventions renvoyées ; {{leader}} est en tête des attributions en cours ({{open}}).",
contractorCompleted_one: "{{name}} a terminé {{count}} intervention en {{days}} j ; {{leader}} en a {{open}} en cours.",
contractorCompleted_many: "{{name}} a terminé {{count}} d’interventions en {{days}} j ; {{leader}} en a {{open}} en cours.",
contractorCompleted_other: "{{name}} a terminé {{count}} interventions en {{days}} j ; {{leader}} en a {{open}} en cours.",
contractorLeader: "{{leader}} a la plus forte charge de travail parmi les prestataires ({{open}} en cours).",
},
siteRisk: {
whyTwoDrivers: "Santé opérationnelle {{score}}/100 — risque lié à {{first}} et à {{second}}.",
whyOneDriver: "Santé opérationnelle {{score}}/100 — risque lié à {{driver}}.",
whyExposure: "Santé opérationnelle {{score}}/100 — exposition opérationnelle {{risk}}/100.",
subLabelExposure: "Exposition opérationnelle {{risk}}/100",
},
rootCause: {
assetCount_one: "{{count}} actif",
assetCount_many: "{{count}} d’actifs",
assetCount_other: "{{count}} actifs",
dayCount_one: "{{count}} jour",
dayCount_many: "{{count}} de jours",
dayCount_other: "{{count}} jours",
jobCount_one: "{{count}} intervention",
jobCount_many: "{{count}} d’interventions",
jobCount_other: "{{count}} interventions",
categoryJobs_one: "{{count}} intervention de catégorie {{category}}",
categoryJobs_many: "{{count}} d’interventions de catégorie {{category}}",
categoryJobs_other: "{{count}} interventions de catégorie {{category}}",
itemFailures_one: "{{count}} échec de l’élément « {{label}} »",
itemFailures_many: "{{count}} d’échecs de l’élément « {{label}} »",
itemFailures_other: "{{count}} échecs de l’élément « {{label}} »",
categoryIssues_one: "{{count}} problème « {{category}} »",
categoryIssues_many: "{{count}} de problèmes « {{category}} »",
categoryIssues_other: "{{count}} problèmes « {{category}} »",
jobReopens_one: "{{count}} réouverture d’intervention",
jobReopens_many: "{{count}} de réouvertures d’intervention",
jobReopens_other: "{{count}} réouvertures d’intervention",
reopenCount_one: "{{count}} réouverture",
reopenCount_many: "{{count}} de réouvertures",
reopenCount_other: "{{count}} réouvertures",
likelyDriver: "Facteur probable : {{driver}}",
titleJobCategory: "Schéma récurrent : {{jobs}} sur {{assets}} en {{days}}",
driverJobCategory: "la catégorie de travaux {{category}} revient sur des actifs similaires.",
driverJobCategoryScope: "Le même déclencheur opérationnel ou le même périmètre de checklist est peut-être insuffisamment traité.",
counterJobCategory: "La maintenance planifiée peut légitimement répéter la même catégorie — vérifiez les planifications.",
actionJobCategory: "Revoyez le périmètre des travaux de catégorie {{category}} et la méthode de réparation, puis inspectez les actifs liés.",
titleInspectionItem: "Schéma récurrent : {{failures}} sur {{assets}} en {{days}}{{site}}",
siteSame: " sur le même site",
siteMultiple: " sur plusieurs sites",
driverInspectionItem: "le même élément d’inspection échoue de façon répétée ({{label}}).",
driverInspectionItemScope: "Périmètre de la checklist, conditions environnementales ou vérification de la réparation sur cet élément.",
counterInspectionItem: "Des campagnes d’inspection saisonnières ou ponctuelles peuvent regrouper temporairement les échecs.",
actionInspectionItem: "Revoyez l’élément de checklist « {{label}} » et inspectez les actifs liés sur site.",
titleAssetRepeat: "Schéma récurrent : {{asset}} de nouveau en panne après réparation ({{jobs}} en {{days}})",
driverAssetRepeat: "la même catégorie de panne réapparaît après réparation.",
driverAssetRepeatCause: "La méthode de réparation, les pièces ou le défaut d’origine n’ont peut-être pas été corrigés.",
counterAssetRepeat: "Le travail de suivi est peut-être une vérification planifiée — confirmez l’objet de l’intervention.",
actionAssetRepeat: "Revoyez la méthode de réparation et inspectez les actifs liés.",
latestRepair: "Dernière réparation",
postRepairInspection: "Inspection après réparation avec échecs",
titleFailureType: "Schéma récurrent : {{issues}} sur les actifs de type {{assetType}} ({{assets}}, {{days}})",
driverFailureType: "les défaillances « {{category}} » se concentrent sur le type d’actif {{assetType}}.",
counterFailureType: "Ce type d’actif compte peut-être peu d’actifs — vérifiez que l’échantillon est représentatif.",
actionFailureType: "Revoyez les normes « {{category}} » pour les actifs de type {{assetType}} et les éléments de checklist associés.",
titleTechReopen: "Schéma récurrent : {{reopens}} pour {{name}} en {{days}}",
driverTechReopen_one: "réouvertures répétées des interventions de {{name}} dans {{count}} catégorie.",
driverTechReopen_many: "réouvertures répétées des interventions de {{name}} dans {{count}} de catégories.",
driverTechReopen_other: "réouvertures répétées des interventions de {{name}} dans {{count}} catégories.",
driverTechReopenCause: "Les critères de clôture, les pièces ou la qualité de la passation sont peut-être à revoir.",
counterTechReopen: "Les réouvertures peuvent refléter des rappels de clients sans lien avec les compétences du technicien.",
actionTechReopen: "Examinez les interventions rouvertes avec {{name}} et vérifiez les critères de clôture.",
titleVendorReopen: "Schéma récurrent : {{reopens}} avec le prestataire {{name}} en {{days}}",
driverVendor: "le prestataire {{name}} est lié à des réouvertures répétées.",
counterVendor: "Les pics de charge d’un prestataire peuvent coïncider avec des réouvertures sans problème de qualité.",
actionVendor: "Examinez les performances et le périmètre du prestataire {{name}}.",
titlePart: "Schéma récurrent : {{jobs}} impliquant « {{part}} » sur {{assets}} en {{days}}",
driverPart: "la pièce ou catégorie « {{part}} » est associée à des interventions répétées.",
counterPart: "Le réassort ou les kits de maintenance planifiée peuvent légitimement faire revenir la même pièce sur plusieurs actifs.",
actionPart: "Vérifiez la qualité, l’ajustement et le périmètre de maintenance planifiée pour « {{part}} ».",
assetFallback: "Actif",
jobFallback: "Intervention",
contractorFallback: "Prestataire",
checklistItemFallback: "Élément de checklist",
uncategorised: "Sans catégorie",
impactRecurrence: "Récurrence",
impactRecurrenceValue_one: "{{events}} en {{count}} jour",
impactRecurrenceValue_many: "{{events}} en {{count}} de jours",
impactRecurrenceValue_other: "{{events}} en {{count}} jours",
reviewPattern: "Examiner le schéma",
viewJobs: "Voir les interventions",
},
actionPlans: {
reviewData: "Vérifier les données",
reviewDataDetail: "Confirmez l’historique des inspections et des interventions avant d’engager des ressources.",
withinDays_one: "Sous {{count}} jour",
withinDays_many: "Sous {{count}} de jours",
withinDays_other: "Sous {{count}} jours",
scheduleWithin_one: "Planifier une inspection sous {{count}} jour",
scheduleWithin_many: "Planifier une inspection sous {{count}} de jours",
scheduleWithin_other: "Planifier une inspection sous {{count}} jours",
scheduleWithinDetail: "Vérifiez l’état et recueillez des preuves sur site.",
openAssetRecord: "Ouvrir la fiche de l’actif",
openAssetRecordDetail: "Consultez l’historique, les interventions liées et les résultats de la dernière inspection.",
scheduleInspection: "Planifier une inspection",
benefitDowntime: "Réduire le risque d’arrêt",
benefitCatchDefects: "Détecter les défauts avant la panne",
effortFailureUrgent: "Faible — attribuer un technicien et inspecter l’état des joints",
effortFailure: "Faible — attribuer un responsable et confirmer le périmètre de la checklist",
triageOverdue: "Trier les interventions en retard aujourd’hui",
triageOverdueDetail: "Redéfinissez les priorités, réattribuez ou mettez à jour les échéances.",
escalateBlockers: "Faire remonter les blocages",
escalateBlockersDetail: "Faites ressortir les interventions en attente de pièces, d’accès ou d’approbations.",
today: "Aujourd’hui",
benefitSla: "Rétablir le SLA et freiner la hausse du travail en attente",
effortOverdue: "Moyen — revoir les attributions et les échéances dans tout le groupe",
renewCertificate: "Renouveler le certificat avant expiration",
renewCertificateDetail: "Réservez la certification ou l’inspection de conformité avant l’échéance.",
openCompliance: "Ouvrir l’espace Conformité",
openComplianceDetail: "Confirmez les responsables et les dates de renouvellement de chaque actif.",
beforeExpiry: "Avant expiration (30 jours)",
benefitCompliance: "Éviter un manquement de conformité et une exposition en cas d’audit",
effortCompliance: "Faible — confirmer le responsable du renouvellement et les échéances",
reviewReopened: "Examiner les interventions rouvertes et prévoir un accompagnement",
reviewReopenedDetail: "Passez en revue les échecs répétés avec le technicien dans les catégories concernées.",
viewContacts: "Voir les contacts",
viewContactsDetail: "Vérifiez la charge de travail et les binômes pour le suivi correctif.",
thisWeek: "Cette semaine",
benefitRework: "Réduire les reprises et améliorer le taux de réparation du premier coup",
effortTraining: "Moyen — accompagner sur les tendances par catégorie et vérifier les critères de clôture",
createJob: "Créer une intervention",
scheduleOverdue: "Planifier les inspections des actifs en retard",
scheduleOverdueDetail: "Comblez la lacune de couverture de 90 jours avec des checklists issues de check-lists.",
openInspections: "Ouvrir l’espace Inspections",
openInspectionsDetail: "Planifiez plusieurs inspections à la fois ou démarrez-en une depuis l’espace Inspections.",
benefitCoverage: "Rétablir la couverture d’inspection et la visibilité des risques",
effortInspection: "Faible — choisir une check-list et attribuer les inspecteurs",
reviewPattern: "Examiner le schéma récurrent",
inspectRelated: "Inspecter les actifs liés",
inspectRelatedDetail: "Parcourez les actifs du groupe et vérifiez la méthode de réparation, les pièces et le périmètre de la checklist.",
reviewSupporting: "Examiner les interventions et inspections associées",
reviewSupportingDetail: "Confirmez les preuves avant de modifier les normes.",
patternWindow: "Schéma · {{value}}",
benefitCycles: "Briser les cycles de pannes répétées et réduire les reprises",
effortRootCause: "Moyen — recouper les interventions, les inspections et l’historique des réparations",
viewJobs: "Voir les interventions",
startAssignedJob: "Ouvrir et démarrer l’intervention attribuée",
dueWindow: "Échéance · {{value}}",
whenDue: "À l’échéance",
benefitOnTrack: "Garder le travail attribué dans les temps",
effortNextJob: "Faible — ouvrir l’intervention et publier une première mise à jour",
openJob: "Ouvrir l’intervention",
},
};
